function smoothScroll() {

	$('.site a[href*="#"]').click(function(e) {

		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			e.preventDefault();

			// Offset
			let offset = 100;

			// Breakpoint lg offset
			if (window.matchMedia('(min-width: 1248px)').matches) {
				offset = 40;
			}

			let target = $(this.hash);
			target = target.length ? target : '';

			// Scroll to hash and focus
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - offset
				}, 500, function() {
					var $target = $(target);
					$target.focus();
					if ($target.is(':focus')) {
						return false;
					} else {
						$target.attr('tabindex','-1');
						$target.focus();
					};
				});
			}

		}

	});

}